import React, { FC } from 'react';
import classNames from 'classnames';
import Comma from '../../../components/Comma';
import PatentStatCard from './PatentStatCard';
import PatentBarChart from './PatentBarChart';
import styles from './ResearchCooperation.module.scss';
import { ResearchCooperationData } from '../type';

/**
 * 科研合作数据展示组件
 * 展示专利布局、专利授权统计卡片，以及历年累计专利授权数量柱状图
 */
const ResearchCooperation: FC<ResearchCooperationData> = (props) => {
  const { titleMain, titleVice, desc, patentStatsArr, patentYearDataArr, chartDesc } = props;

  return (
    <div className={styles['research-cooperation']}>
      {/* 标题 */}
      <div className={styles['research-cooperation-title']}>
        <span className={styles['research-cooperation-title-item']}>{titleMain}</span>
        {titleVice && (
          <span className={styles['comma-box']}>
            <Comma />
          </span>
        )}
        <span className={styles['research-cooperation-title-item']}>{titleVice}</span>
      </div>
      {/* 描述文案 */}
      <div className={styles['research-cooperation-desc']}>{desc}</div>

      <div className={styles['research-cooperation-content']}>
        {/* 左侧：专利统计卡片 */}
        <div className={styles['patent-stat-list']}>
          {patentStatsArr.map((item, index) => (
            <PatentStatCard key={index} {...item} />
          ))}
        </div>

        {/* 右侧：专利授权数量柱状图 */}
        <div className={classNames(styles['patent-chart-wrap'])}>
          <PatentBarChart dataArr={patentYearDataArr} desc={chartDesc} />
        </div>
      </div>
    </div>
  );
};

ResearchCooperation.displayName = 'ResearchCooperation';
export default ResearchCooperation;
